<script>
    export let sidebarStep;
</script>
<div class="pl-sidebar">
    <ul class="list-none flex column-direction flex-wrap">
        <li><button class="pl-nav {sidebarStep === 1 ? 'active' : ''}">Project Details</button></li>
        <li><button class="pl-nav {sidebarStep === 2 ? 'active' : ''}">Redeemable</button></li>
        <li><button class="pl-nav {sidebarStep === 3 ? 'active' : ''}">Parameters</button></li>
        <li><button class="pl-nav {sidebarStep === 4 ? 'active' : ''}">Seed</button></li>
    </ul>
</div>